export { positionElements, Positioning } from './ng-positioning'
export { PositioningService, PositioningOptions } from './positioning.service';



// WEBPACK FOOTER //
// C:/Users/bompadre/Documents/angular2/myapp2/node_modules/angular-bootstrap-md/utils/positioning/index.ts